import request from "@/utils/request";
import { pagPromise, noPagePromise } from "./setPromise";

// 登录
export function Login(data) {
  return request({
    url: "/api/SystemMethod/Login",
    method: "post",
    data
  });
}

// 登录后获取有权限的菜单
export function fetchGetMenu(data) {
  return request({
    url: "/api/AdminUserMethod/GetMenu",
    method: "post",
    data
  });
}

// 认证
export function UserAuthentication(data) {
  return request({
    url: "/api/SystemMethod/UserAuthentication",
    method: "post",
    data
  });
}

// 发送验证码
export function GetVerificationCode(data) {
  return request({
    url: "/api/SystemMethod/GetVerificationCode",
    method: "post",
    data
  });
}

// 获取自身信息
export function SearchMyInformation(data) {
  console.log(" ", data);
  return request({
    url: "/api/SystemMethod/SearchMyInformation",
    method: "post",
    data
  });
}

// 用户注册接口
export function RegisteredAccount(data) {
  return request({
    url: "/api/SystemMethod/RegisteredAccount",
    method: "post",
    data
  });
}

// 获取用户身份接口
export function GetUserIdentityList(data) {
  return noPagePromise;
  // return request({
  //   url: "/api/SystemMethod/GetUserIdentityList",
  //   method: "post",
  //   data
  // });
}

// 查询账户是否存在
export function SearchLoginCodeExistOrNot(data) {
  return request({
    url: "/api/SystemMethod/SearchLoginCodeExistOrNot",
    method: "post",
    data
  });
}
// 获取邮箱验证码
export function GetMailBoxVerificationCode(data) {
  return request({
    url: "/api/SystemMethod/GetMailBoxVerificationCode",
    method: "post",
    data
  });
}
// 校验邮箱验证码
export function VerifyMailBoxVerificationCode(data) {
  return request({
    url: "/api/SystemMethod/VerifyMailBoxVerificationCode",
    method: "post",
    data
  });
}
// 重置密码
export function ResetPassword(data) {
  return request({
    url: "/api/SystemMethod/ResetPassword",
    method: "post",
    data
  });
}

// 通过数据和模版生成文件
export function fetchDataAndTemplateToFile(data) {
  return request({
    url: "/DAT2F/generateMulti",
    method: "post",
    data,
    disableTrim: true,
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js